import * as React from 'react';
import { Theme, withStyles, WithStyles, createStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import StatsItem from './StatsItem';
import { localizations } from '../../localization/localization';

const styles = (theme: Theme) => createStyles({
  mediaNoticeContainer: {
    padding: '4.6875em',
    paddingTop: '2.375em',
    paddingBottom: '2.375em',
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    }
  },
  mediaNoticeContainerMobile: {
    paddingTop: '2.375em',
    paddingBottom: '2.375em',
    [theme.breakpoints.down('sm')]: {
      padding: '3em',
    }
  },
  mediaNoticeBox: {
    maxWidth: 448,
    backgroundColor: '#033349',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    padding: '2.0625em',
    paddingLeft: '2.25em',
    paddingRight: '2.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  mediaNoticeBoxMobile: {
    maxWidth: 448,
    backgroundColor: '#033349',
    borderTop: `5px solid ${theme.palette.secondary.main}`,
    paddingTop: '2.0625em',
    paddingBottom: '2.0625em',
    paddingLeft: '1em',
    paddingRight: '1em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.2941em'
    },
  },
  mediaLogoUsageContainer: {
    justifyContent: 'flex-start',
    paddingLeft: '0.25em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.323em',
      marginTop: 30
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      paddingLeft: '4.688em',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    }
  },
  mediaLogoUsageContainerMobile: {
    justifyContent: 'flex-start',
    paddingLeft: '1em',
    paddingRight: '1em',
    '& > div:first-child': {
      color: 'white',
      fontSize: '2.125em',
      fontWeight: 'bold',
      lineHeight: 1.353,
      marginBottom: '0.323em',
      marginTop: 30
    },
    [theme.breakpoints.up('md')]: {
      alignItems: 'flex-start',
      paddingLeft: '4.688em',
      flex: 1
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    }
  },
});


const MediaNoticeContainer: React.SFC<WithStyles & { isMobile?: boolean; }> = ({
  classes,
  isMobile
}) => {
  return (
    <Grid item container direction="row" className={isMobile === false ? classes.mediaNoticeContainer : classes.mediaNoticeContainerMobile}>
      <Grid item container direction="column" className={isMobile === false ? classes.mediaNoticeBox : classes.mediaNoticeBoxMobile}>
        <Grid item>{localizations.mediaPageView.notice}</Grid>
        <Grid item>
            <p>{localizations.mediaPageView.noticeParagraph01}</p>
            <p><b>{localizations.mediaPageView.noticeParagraph02}</b></p>
            <p>{localizations.mediaPageView.noticeParagraph03}</p>
        </Grid>
      </Grid>
      <Grid item container direction="column" className={isMobile === false ? classes.mediaLogoUsageContainer : classes.mediaLogoUsageContainerMobile}>
        <Grid item>{localizations.mediaPageView.logoUsage}</Grid>
        <Grid item>
            <p>{localizations.mediaPageView.logoUsageParagraph01}</p>
            <p><b>{localizations.mediaPageView.logoUsageParagraph02}</b></p>
            <p>{localizations.mediaPageView.logoUsageParagraph03}</p>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default withStyles(styles)(MediaNoticeContainer);



// WEBPACK FOOTER //
// ./src/landingPage/components/MediaNoticeContainer.tsx